import React, { Component } from 'react'
import Select from 'react-select';
import { BACKEND_URL } from '../../../config/constants';
import LogoCliente from '../../HeaderLogos';

class InsightcareHeaderPS extends Component {
  render() {
    const { title, dataDorToracica, dataAVCDerrame, dataPacientes = [], tipoSelecionado, pacienteSelecionado, selecionarPaciente, onVoltar } = (this.props);

    if (tipoSelecionado === null) {
      let spanAlerta = '';

      if (dataDorToracica !== null && dataAVCDerrame !== null) {
        spanAlerta = (
          <>
            <span><img src="/img/icon-triangle-exclamation-regular.svg" alt="" />Atenção!</span>
            <span>Dor torácica: {dataDorToracica}</span>
            <span>AVC/Derrame: {dataAVCDerrame}</span>
          </>
        );
      } else if (dataDorToracica !== null) {
        spanAlerta = (
          <>
            <span><img src="/img/icon-triangle-exclamation-regular.svg" alt="" />Atenção! Paciente com dor torácica:</span>
            <span>{dataDorToracica}</span>
          </>
        );
      } else if (dataAVCDerrame !== null) {
        spanAlerta = (
          <>
            <span><img src="/img/icon-triangle-exclamation-regular.svg" alt="" />Atenção! Paciente com AVC/Derrame:</span>
            <span>{dataAVCDerrame}</span>
          </>
        );
      }

      return (
        <div className='headerPS'>
          <div className='headerPS-title'>
            {title}
          </div>
          {(dataDorToracica !== null || dataAVCDerrame !== null) && (
            <div className='headerPS-paciente'>
              {spanAlerta}
            </div>
          )}
          <div className='headerPS-logo'>
            <img src="/img/insightcare_lamp.svg" alt="InsightCare" />
            <img src={"/img/powered_insightcare.svg"} alt="Insightcare" style={{ height: '2.5vh', marginLeft: '10px', borderRight: '2px solid #ccc', paddingRight: '16px' }} />
            <LogoCliente backendUrl={BACKEND_URL} style={{ paddingLeft: '16px' }} />
          </div>
        </div>
      )
    } else {
      return (
        <div className='headerPS'>
          <div className='headerPS-title'>
            <img src="/img/icon_arrow_left_2.svg" alt="InsightCare" onClick={onVoltar} />
            {title}
          </div>
          <div className='headerPS-search'>
            <div className='buttonSearch'>
              <img src="/img/icon_search.svg" alt="" />
              <Select
                className='selectSearch'
                placeholder="Busque por um paciente..."
                options={
                  dataPacientes.map(opt => ({
                    key: opt.CODIGOPACIENTE,
                    label: `${opt.NOMEPACIENTE} (${opt.CODIGOATENDIMENTO})`,
                    value: opt.CODIGOPACIENTE,
                  }))}
                value={
                  dataPacientes
                    .map(opt => ({
                      key: opt.CODIGOPACIENTE,
                      label: `${opt.NOMEPACIENTE} (${opt.CODIGOATENDIMENTO})`,
                      value: opt.CODIGOPACIENTE,
                    }))
                    .find(o => o.value === pacienteSelecionado) || null
                }
                isClearable={true}
                onChange={opt => {
                  if (opt) {
                    selecionarPaciente(opt.value);
                  } else {
                    selecionarPaciente(null);
                  }
                }}
              />
            </div>
          </div>
          <div className='headerPS-logo'>
            <img src="/img/insightcare_lamp.svg" alt="InsightCare" />
            <img src={"/img/powered_insightcare.svg"} alt="Insightcare" style={{ height: '2.5vh', marginLeft: '10px', borderRight: '2px solid #ccc', paddingRight: '16px' }} />
            <LogoCliente backendUrl={BACKEND_URL} style={{ paddingLeft: '16px' }} />
          </div>
        </div>
      )
    }
  }
}

export default InsightcareHeaderPS;
